import React from "react"
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Trans} from "@lingui/macro";

interface DeleteDocumentModalProps {
    onClose: () => void
    onDelete: () => void
}

interface DeleteDocumentModalState {

}

export class DeleteDocumentModal extends React.Component<DeleteDocumentModalProps, DeleteDocumentModalState>
{
    render(){
        return(
            <Dialog open={true} onClose={this.props.onClose}>
                <DialogTitle>
                    <Trans id={"delete-document-modal.title"}>
                        Eliminazione documento
                    </Trans>
                </DialogTitle>
                <DialogContent>
                    <Trans id={"delete-document-modal.body"}>
                        Sicuro di voler eliminare il documento selezionato? L'operazione è irreversibile.
                    </Trans>
                </DialogContent>
                <DialogActions sx={{pr:2}}>
                    <Button onClick={this.props.onClose}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 1,
                                width: 100
                            }}
                            disableElevation>
                        <Trans id={"delete-document-modal.abort"}>
                            Annulla
                        </Trans>
                    </Button>
                    <Button onClick={this.props.onDelete}
                            variant="contained"
                            sx={{
                                backgroundColor: 'secondary.main',
                                color: 'white',
                                mr: 1,
                                textTransform: "none",
                                width: 100
                            }}
                    >
                        <Trans id={"delete-document-modal.confirm"}>
                            Conferma
                        </Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
